export default {
  data() {
    return {
      zipReg1: /^\d{5}$|^\d{5}-\d{4}$/,
      zipReg2: /^\d{5}$/,
      zipReg3: /^\d{9}$/,
    };
  },
  methods: {
    // isValidZip(zip) {
    //   if (!zip || zip.length < 1) return true;
    //   return this.zipReg1.test(zip) || this.zipReg2.test(zip) || this.zipReg3.test(zip);
    // },
    isValidZip(zip) {
      const regexZip = (/^(?:[aA-zZ0-9-]*)$/gm);
      if (!zip || zip.length < 1) return true;
      return regexZip.test(zip.trim());
    },
    maskZip(zip) {
      let p = zip;
      if (!zip || zip.trim().length < 1) return p;
      p = p.toString().replace(/\D+/g, '').replace(/(\d{5})(\d{4})/, '$1-$2');
      return p;
    },
    unmaskZip(zip) {
      let p = zip;
      if (!zip || zip.trim().length < 1) return p;
      p = p.replace(/\D/g, '');
      return p;
    },
  },
};
